import helpPopup from './helpPopup';
import app from '$$app';

const __ = window.__;
const _PROTO_NAME = 'helpIcon';

// {Object} -> {String}
const _getIconTemplate = ({ isUsed, iconSize }) => `
  <div class="help-icon ${isUsed ? 'activity_used' : ''}">
    <div class="help-icon-inner">
      <svg width="${iconSize}" height="${iconSize}" viewBox="0 0 ${iconSize} ${iconSize}" xmlns="http://www.w3.org/2000/svg">
        <use xmlns:xlink="http://www.w3.org/2000/svg"
          xlink:href="#icons/regular/${iconSize}/help"
          href="#icons/regular/${iconSize}/help"
        ></use>
      </svg>
    </div>
  </div>
`;

// V P from MVP
webix.protoUI({
  name: _PROTO_NAME,
  _id: null,
  // ???
  $skin() {
    this.defaults.height = webix.skin.$active.inputHeight;
  },
  // initialization of the component
  $init(config) {
    // console.info('help icon $init', config.id, this); // !DEBUG

    this._id = config.dataId;
    this.id = config.id;

    if (config.iconSize) {
      setTimeout(() => {
        $$(this.id).setValues({ iconSize: config.iconSize }, true);
      });
    }

    // this._handleChangeFeature = this._handleChangeFeature.bind(this);
    // this._initModelComplete = this._initModelComplete.bind(this);

    app.on('user:activities:loaded', this._onUserActivitiesLoadedHandler.bind(this));

    if (app.callGlobalStore && this._id) {
      const activityStatus = app.callGlobalStore('getter', 'user/getActivityStatus', [this._id]);
      setTimeout(() => {
        $$(this.id) && $$(this.id).setValues({ isUsed: activityStatus === 1 }, true);
      }, 0);
    }

    // this.setValues({ isUsed: true }); // !FIXME
  },
  defaults: {
    data: { isUsed: false, iconSize: 24 },
    template: _getIconTemplate,
    width: 50,
    on: {
      onItemClick(iconId, mouseEvent) {
        helpPopup.showHelpBlock(mouseEvent, this._id); // compatibility
        app.callGlobalStore('action', 'user/updateActivityStatus', [{
          activityName: this._id,
          status: 1,
        }]);
        $$(this.id) && $$(this.id).setValues({ isUsed: true }, true);
      },
    },
  },
  //
  _onUserActivitiesLoadedHandler(activities) {
    const currentHelpActivity = activities.find(entry => entry.name === this._id);

    if (!currentHelpActivity) {
      return;
    }

    const currentHelpActivityStatus = currentHelpActivity.activity_status;
    if (this.getNode() && this.getNode().hasChildNodes()) {
      this.setValues({
        isUsed: currentHelpActivityStatus === 1,
      }, true);
    }
  },
  _onUserActivityUpdatedHandler(activity) {
    const { name, activity_status } = activity;

    if (name === this._id) {
      $$(this.id) && $$(this.id).setValues({ isUsed: activity_status === 1 }, true);
    }
  },
}, webix.ui.template, webix.ui.button, webix.EventSystem);

export default {};

// onItemClick: function (iconId, mouseEvent) {
//   if (this.config.data === "importProjectBlock") {
//     this.config.id = "importProjectBlock";
//     this.getNode().firstChild.classList.add('activity_used');
//   } else if (this.config.data === "newProjectBlock") {
//     this.config.id = "newProjectBlock";
//     this.getNode().firstChild.classList.add('activity_used');
//   } else if (this.config.data === undefined){
//     // костыль
//     this.config.id = iconId;
//   }
// helpPopup.showHelpBlock(mouseEvent, this.config.id);
// // класс при открытом окне (backdrop)
// this.getNode().firstChild.classList.add('active-help');
// // серый цвет
// this.getNode().firstChild.classList.add('activity_used');
// }

// onItemClick: function (iconId, mouseEvent) {
//   if (this.config.data === "importProjectBlock") {
//     this.config.id = "importProjectBlock";
//     this.getNode().firstChild.classList.add('activity_used');
//   } else if (this.config.data === "newProjectBlock") {
//     this.config.id = "newProjectBlock";
//     this.getNode().firstChild.classList.add('activity_used');
//   } else if (this.config.data === undefined){
//     // костыль
//     this.config.id = iconId;
//   }
